<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-4">
          <div slot="header">
            <h4 class="card-title pl-1 f-20-mobile">Subir Produtos Pizza por Planilha</h4>
          </div>
          <div class="col-md-6 mb-3">
            <label>Empresa originária dos dados (Buscar por idi ou CNPJ)</label>
              <input type="text" v-model="pesquisa_original" v-debounce:250ms="pesquisaInstalacaoOriginal" class="form-control">
              <div class="mt-2 bold">
                 <div>Idi: {{ empresa_original.idi }}</div>
                 <div>CNPJ: {{ empresa_original.cnpj }}</div>
                 <div>Apelido: {{ empresa_original.apelido }}</div>
                 <div>R. Social: {{ empresa_original.razao_social }}</div>
              </div>
          </div>
          <div class="col-md-6 mb-3 pl-0">
          <input ref="inputFile" :disabled="!empresa_original || !empresa_original.idi" type="file" @change="processFile($event)" class="form-control">
          </div>
          <div class="pt-3 pb-1 d-inline">
            <button :disabled="error || !planilha || !pesquisa_original || !(empresa_original && empresa_original.idi)" class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary" @click="subirPlanilha">Subir pizzas</button>
          </div>
          <div class="pt-3 pb-1 d-inline ml-4">
            <a href="template_pizza.csv" class="btn btn btn-round btn-wd btn-linkedin mx-auto-mobile mb-2-mobile btn-primary">Baixar o template</a>
          </div>

          <div v-if="error" style="color: red; font-weight: bold;">Arquivo inválido, verifique-o e tente novamente</div>
          <div v-for="err of err_data">{{ err }} </div>

          <div class="changelog mt-4" v-if="!error && csvDecodificado">
            <table class="table table-bordered">
              <thead>
                <th v-for="header of csvDecodificado[0]">{{ header }}</th>
              </thead>
              <tbody>
                <template v-for="(row, index) of csvDecodificado">
                  <tr v-if="index !== 0">
                    <template v-for="line of row">
                      <td :class="line.status" :title="line.oldValue">{{ line.newValue }}</td>
                    </template>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import {
  Card,
} from 'src/components'
import moment from 'moment'
import "vue-select/dist/vue-select.css";
import loadApp from '@/services/InstalacaoService.js'
import AuthService from '@/services/AuthService.js'

export default {
    components: {
      Card,
      moment,
    },
    data() {
      return {
        planilha:null,
        csvDecodificado: 0,
        success:false,
        fail:false,
        idi:null,
        mensagem_erro:null,
        pesquisa_original:"",
        empresa_original:{
          idi: ''
        },
        empresa: '',
        json_data: [],
        error: false,
        err_data: [],
        pizzas: [],
        massas: [],
        bordas: [],
        sabores: [],
        adicionais: []
      }
    },
    methods:{
      processFile(event) {
        var reader = new FileReader();
        reader.onload = (e)=>{
          this.planilha = e.target.result

          this.validateCSV(this.planilha)
        }
        
        reader.readAsText(event.target.files[0])
      },
      async validateCSV(planilha) {   
        this.error = false;     
        let csv = this.planilha.split(/\r?\n|\r|\n/g)

        let ordem = 0;
        let pizzas = []
        let massas = []
        let bordas = []
        let sabores = []
        let adicionais = []

        for(let row of csv) {
          if(row.split(';').length) {
            let splitado = row.split(';');

            //================================================================
            // Cabecalhos
            //================================================================

            if(splitado[0] === 'Pizzas' && ordem == 0) {
              ordem = 1;

              console.log("Ordem 1")

              continue;
            }

            if(splitado[0] === 'Massas' && ordem == 2) {
              ordem = 3;

              console.log("Ordem 3")

              continue;
            }

            if(splitado[0] === 'Bordas' && ordem == 4) {
              ordem = 5;

              console.log("Ordem 5")

              continue;
            }

            if(splitado[0] === 'Sabores' && ordem == 6) {
              ordem = 7;

              console.log("Ordem 7")

              continue;
            }

            if(splitado[0] === 'Adicionais' && ordem == 8) {
              ordem = 9;

              console.log("Ordem 9")

              continue;
            }

            //================================================================
            // Dados
            //================================================================

            // Todos a partir da ordem 1 serão pizzas, logo precisa validar
            if(ordem === 1) {
              if(splitado[0] === '') {
                console.log('============== VAZIO ordem 1 =============')
                ordem += 1;
                continue;
              }

              let pizza = {
                nome: splitado[0],
                categoria: splitado[1],
                descricao: splitado[2],
                quantidade_sabores: splitado[3],
                imagem: splitado[4],
                ncm: splitado[5],
                cfop: splitado[6],
                cst: splitado[7],
                codigo_pdv: splitado[8],
                codigo_fiscal: splitado[9]
              }

              pizzas.push(pizza)
            }

            // Todos a partir da ordem 3 serão massas, logo precisa validar

            if(ordem === 3) {
              if(splitado[0] === '') {
                console.log('============== VAZIO ordem 3 =============')
                ordem += 1;
                continue;
              }

              let massa = {
                nome: splitado[0],
                descricao: splitado[1],
                imagem: splitado[2],
                codigo_pdv: splitado[3],
                precos: []
              }

              for(let i = 0; i < pizzas.length; i++) {
                massa.precos.push(parseFloat(splitado[4 + i]))
              }

              massas.push(massa)
            }

            // Todos a partir da ordem 5 serão bordas, logo precisa validar

            if(ordem === 5) {
              if(splitado[0] === '') {
                console.log('============== VAZIO ordem 5 =============')
                ordem += 1;
                continue;
              }

              let borda = {
                nome: splitado[0],
                descricao: splitado[1],
                imagem: splitado[2],
                codigo_pdv: splitado[3],
                precos: []
              }

              for(let i = 0; i < pizzas.length; i++) {
                borda.precos.push(parseFloat(splitado[4 + i]))
              }

              bordas.push(borda)
            }

            // Todos a partir da ordem 7 serão sabores, logo precisa validar

            if(ordem === 7) {
              if(splitado[0] === '') {
                console.log('============== VAZIO ordem 7 =============')
                ordem += 1;
                continue;
              }

              let sabor = {
                nome: splitado[0],
                descricao: splitado[1],
                imagem: splitado[2],
                codigo_pdv: splitado[3],
                precos: []
              }

              for(let i = 0; i < pizzas.length; i++) {
                sabor.precos.push(parseFloat(splitado[4 + i]))
              }

              sabores.push(sabor)
            }

            // Todos a partir da ordem 9 serão sabores, logo precisa validar

            if(ordem === 9) {
              if(splitado[0] === '') {
                console.log('============== VAZIO ordem 9 =============')
                ordem += 1;
                continue;
              }

              let adicional = {
                nome: splitado[0],
                descricao: splitado[1],
                imagem: splitado[2],
                codigo_pdv: splitado[3],
                precos: []
              }

              for(let i = 0; i < pizzas.length; i++) {
                adicional.precos.push(parseFloat(splitado[4 + i]))
              }

              adicionais.push(adicional)
            }
          }
        }

        if(!pizzas.length) {
          this.err_data.push('Adicional inválido')
          this.error = true

          for(let pizza of pizzas) {
            if(!pizza.quantidade_sabores) {
              this.err_data.push('Existem pizzas sem sabores')
              this.error = true
            }
          }
        }

        if(!sabores.length) {
          this.error = true
        }

        this.pizzas = pizzas;
        this.massas = massas;
        this.bordas = bordas;
        this.sabores = sabores;
        this.adicionais = adicionais;

        let produtos = []

        if(!this.error) {
          this.error = false;
          let csvDecoded = this.planilha.split(/\r?\n|\r|\n/g)
          let data = []

          let i = 0;
          
          for(let row of csvDecoded) {
            let rowSplitada = row.split(';')
            
            if(i > 0) {
              let produtoEncontrado = produtos.find(el => el.Id == rowSplitada[0])

              if(produtoEncontrado) {
                let index = 0; 

                for(const [key, value] of Object.entries(produtoEncontrado)) {
                  if(rowSplitada[index] == value || (rowSplitada[index] == '' && value == null)) {
                    rowSplitada[index] = {
                      oldValue: value,
                      newValue: rowSplitada[index],
                      status: 'unchanged'
                    }
                  } else {
                    rowSplitada[index] = {
                      oldValue: value,
                      newValue: rowSplitada[index],
                      status: 'changed'
                    }
                  }

                  index++;
                }
              } else {
                let novo = false; 

                if(rowSplitada[0] == '' || rowSplitada[0] == null) {
                  novo = true
                }

                for(let index = 0; index < rowSplitada.length; index++) {
                  rowSplitada[index] = {
                    oldValue: '',
                    newValue: rowSplitada[index],
                    status: ''
                  }
                }
              }


            }
            data.push(rowSplitada)
           
            i++;
          }

          this.csvDecodificado = data
        }

        this.$forceUpdate()
      },
      subirPlanilha(){
        if(this.error) {
          return
        }

        let data = {
          idi: this.empresa_original.idi,
          template: {
            pizzas: this.pizzas,
            sabores: this.sabores,
            bordas: this.bordas,
            massas: this.massas,
            adicionais: this.adicionais
          },
          pdv: true,
          delivery: true
        }

        axios.post(process.env.VUE_APP_API_MOBILE_URL+'instalacoes/pizza', data).then(res => {
            this.$swal({
              title:"Sucesso!",
              icon:"success",
              text:"Pizzas lançadas com sucesso!"
            })

        }).catch(err=>{
          this.$swal({
            title:"Erro",
            icon:"warning",
            text: err.response.data ? err.response.data.message : 'Erro interno!'
          })
        });
      },
      pesquisaInstalacaoOriginal(){
        loadApp.loadApp(this.pesquisa_original).then(res => {
          this.empresa_original = res.data[0]
          if(!this.empresa_original){
            this.empresa_original = {idi:null,cnpj:"Nenhuma Empresa Encontrada",nome_fantasia:"Nenhuma Empresa Encontrada"}
          }
          this.$forceUpdate()
        }).catch(err => {
          console.error(err)
        })
      },
      clear() {
        this.error = false;
        this.err_data = []
        this.json_data = [];
        this.planilha = null
        this.csvDecodificado = null
        this.$refs.inputFile.value = null;
        this.$forceUpdate()
      }
    }
}
</script>

<style>
  .flex-center-div {
    display: flex;
    align-items: center;
  }

  .changed {
    background-color: #2ecc71;
  }

  .error {
    background-color: red;
    color: white;
  }

  .ignored {
    background-color: #bbb;
  }
</style>
